export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/mapBlue.8bb76c0d.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};